import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, setBlockTracking as _setBlockTracking } from "vue";
const _hoisted_1 = { class: "grid grid-cols-2 gap-6 mb-6" };
const _hoisted_2 = { class: "col-span-2 lg:col-span-1 flex flex-col justify-end" };
const _hoisted_3 = { class: "card" };
const _hoisted_4 = { class: "px-3 lg:px-4 pt-3 pb-2" };
const _hoisted_5 = { class: "font-semibold" };
const _hoisted_6 = { class: "px-3 lg:px-4 pt-2 pb-3 lg:pb-4" };
const _hoisted_7 = { class: "col-span-2 lg:col-span-1 flex flex-col justify-end" };
const _hoisted_8 = { class: "card" };
const _hoisted_9 = { class: "px-3 lg:px-4 pt-3 pb-2" };
const _hoisted_10 = { class: "font-semibold" };
const _hoisted_11 = { class: "divide-y divide-(--default-border-color) border-t border-(--default-border-color) list-unstyled" };
const _hoisted_12 = { class: "flex" };
const _hoisted_13 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_14 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_15 = ["textContent"];
const _hoisted_16 = { class: "text-muted text-xs" };
const _hoisted_17 = ["textContent"];
const _hoisted_18 = ["textContent"];
const _hoisted_19 = { class: "flex" };
const _hoisted_20 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_21 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_22 = ["textContent"];
const _hoisted_23 = { class: "text-muted text-xs" };
const _hoisted_24 = ["textContent"];
const _hoisted_25 = ["textContent"];
const _hoisted_26 = { class: "flex" };
const _hoisted_27 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_28 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_29 = ["textContent"];
const _hoisted_30 = { class: "text-muted text-xs" };
const _hoisted_31 = ["textContent"];
const _hoisted_32 = ["textContent"];
const _hoisted_33 = { class: "flex" };
const _hoisted_34 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_35 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_36 = ["textContent"];
const _hoisted_37 = { class: "text-muted text-xs" };
const _hoisted_38 = ["textContent"];
const _hoisted_39 = ["textContent"];
const _hoisted_40 = { class: "flex" };
const _hoisted_41 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_42 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_43 = ["textContent"];
const _hoisted_44 = { class: "text-muted text-xs" };
const _hoisted_45 = ["textContent"];
const _hoisted_46 = ["textContent"];
const _hoisted_47 = { class: "flex" };
const _hoisted_48 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_49 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_50 = ["textContent"];
const _hoisted_51 = { class: "text-muted text-xs" };
const _hoisted_52 = ["textContent"];
const _hoisted_53 = ["textContent"];
const _hoisted_54 = { class: "flex" };
const _hoisted_55 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_56 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_57 = ["textContent"];
const _hoisted_58 = { class: "text-muted text-xs" };
const _hoisted_59 = ["textContent"];
const _hoisted_60 = ["textContent"];
const _hoisted_61 = { class: "flex" };
const _hoisted_62 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_63 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_64 = ["textContent"];
const _hoisted_65 = { class: "text-muted text-xs" };
const _hoisted_66 = ["textContent"];
const _hoisted_67 = ["textContent"];
const _hoisted_68 = { class: "flex" };
const _hoisted_69 = { class: "px-3 content-center lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_70 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_71 = ["textContent"];
const _hoisted_72 = { class: "text-muted text-xs" };
const _hoisted_73 = ["textContent"];
const _hoisted_74 = ["textContent"];
const _hoisted_75 = {
    key: 0,
    class: "col-span-2"
};
const _hoisted_76 = {
    class: "alert alert-warning shadow-default mb-4",
    role: "alert"
};
const _hoisted_77 = {
    key: 1,
    class: "col-span-2"
};
const _hoisted_78 = {
    class: "alert alert-warning shadow-default mb-4",
    role: "alert"
};
const _hoisted_79 = {
    key: 2,
    class: "col-span-2"
};
const _hoisted_80 = {
    class: "alert alert-warning shadow-default mb-4",
    role: "alert"
};
const _hoisted_81 = { class: "card" };
const _hoisted_82 = { class: "px-3 lg:px-4 pt-3 pb-2" };
const _hoisted_83 = { class: "font-semibold" };
const _hoisted_84 = { class: "w-full relative aspect-4/3 sm:aspect-video lg:aspect-21/9" };
const _hoisted_85 = {
    key: 0,
    class: "absolute inset-0 flex justify-center items-center text-muted z-2",
    style: { "z-index": "2" }
};
import {} from '@ts/common/chart';
import {} from '@ts/common/datasets';
import { ___, getLocale, toFixedNumberStr } from '@ts/common/language';
import { inLimits } from '@ts/common/math';
import { fetchData, HttpError, isHttpErrorWithStatus, isHttpErrorWithValidationData, isObject } from '@ts/common/request';
import LabeledSelect from '@ts/components/form/inputs/LabeledSelect.vue';
import LabeledSlider from '@ts/components/form/inputs/LabeledSlider.vue';
import {} from '@ts/components/form/types';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import { useDeferredChart } from '@ts/common/useDeferredChart';
import { watchThrottled } from '@vueuse/core';
import Chart, {} from 'chart.js/auto';
import { color } from 'chart.js/helpers';
import annotationPlugin from 'chartjs-plugin-annotation';
import { computed, ref, watch } from 'vue';
// Generation token: rapid slider drags (throttled) can fire overlapping requests that
// resolve out of order. Only the newest computation is allowed to write reactive state.
export default /*@__PURE__*/ _defineComponent({
    __name: 'PotentialManager',
    props: {
        data: { default: undefined },
        help: { type: Boolean, default: false },
        selectable: { type: Boolean, default: false }
    },
    setup(__props) {
        Chart.register(annotationPlugin);
        const props = __props;
        const chart = ref(null);
        const containerRef = ref(null);
        let chartObj = undefined;
        const chartShowPotential = ref(false);
        const showPlaceholder = ref(true);
        const error422 = ref(false);
        const referenceGroupIdStr = ref('');
        const referenceGroupId = computed(() => {
            return referenceGroupIdStr.value !== '' ? parseInt(referenceGroupIdStr.value) : undefined;
        });
        // const referenceOptions = ref<{value: string; name: string}[] | undefined>(undefined);
        const referenceOptions = computed(() => {
            if (props.data === undefined)
                return {};
            const opts = {};
            const keys = Object.keys(props.data.reference_groups);
            for (const key of keys) {
                const group = props.data.reference_groups[key];
                opts[key] = { label: group.name };
            }
            return opts;
        });
        const emptyReferenceOption = { label: ___({ en: 'Select a reference group', de: 'Wähle eine Referenzgruppe' }), disabled: true, hidden: true };
        const weightImprovement = ref(0);
        const vo2maxImprovement = ref(0);
        const vlamaxImprovement = ref(0);
        const defaultPotData = {
            percThresholdRel: 0,
            potThresholdRel: NaN,
            thresholdRel: NaN,
            percThresholdAbs: 0,
            potThresholdAbs: NaN,
            thresholdAbs: NaN,
            percFatmaxRel: 0,
            potFatmaxRel: NaN,
            fatmaxRel: NaN,
            percFatmaxAbs: 0,
            potFatmaxAbs: NaN,
            fatmaxAbs: NaN,
            percVo2maxRel: 0,
            potVo2maxRel: NaN,
            vo2maxRel: NaN,
            percVo2maxAbs: 0,
            potVo2maxAbs: NaN,
            vo2maxAbs: NaN,
            percWeight: 0,
            potWeight: NaN,
            weight: NaN,
            percVlamax: 0,
            potVlamax: NaN,
            vlamax: NaN,
            percBmi: 0,
            potBmi: NaN,
            bmi: NaN,
        };
        const potData = ref(defaultPotData);
        let potDataSeq = 0;
        // Create the chart only once its container has a real (non-zero) size, then force a repaint —
        // Firefox otherwise draws into a 0-size/uncomposited canvas (blank until interaction, and never
        // recovers when the card starts off-screen). See useDeferredChart. setData is async (API call),
        // so guard against re-entry while it is in flight (getChart() stays undefined until drawChart).
        let potentialChartCreating = false;
        useDeferredChart(containerRef, {
            create: () => {
                if (potentialChartCreating || props.data === undefined)
                    return;
                potentialChartCreating = true;
                (async () => {
                    try {
                        await setData(props.data);
                        drawChart(props.data);
                    }
                    finally {
                        potentialChartCreating = false;
                    }
                })();
            },
            getChart: () => chartObj,
        });
        watch(() => props.data, async (newValue, oldValue) => {
            if (newValue !== undefined) {
                await setData(newValue);
                // .then((result) => {
                drawChart(newValue);
                // })
                // .catch(() => {});
            }
        }, { deep: true });
        watchThrottled(referenceGroupId, onChangeReference, { throttle: 500 });
        watchThrottled(weightImprovement, onChangePotential, { throttle: 500 });
        watchThrottled(vlamaxImprovement, onChangePotential, { throttle: 500 });
        watchThrottled(vo2maxImprovement, onChangePotential, { throttle: 500 });
        async function onChangePotential() {
            if (props.data !== undefined) {
                await computeAndSetPotData(props.data);
                // .then((result) => {
                // console.log('onChangeReference - computeAndSetPotData - then - newValue', props.data)
                drawChart(props.data);
                // })
                // .catch((error) => {
                // console.error(error);
                // });
            }
        }
        function onChangeReference() {
            if (props.data !== undefined)
                drawChart(props.data);
        }
        async function setData(data) {
            referenceGroupIdStr.value = String(data.reference_group_id);
            // referenceOptions.value = Object.values(data.reference_groups).map((group: ReferenceGroup, index: number) => {
            //   return {
            //     value: index.toString(),
            //     name: group.name,
            //   };
            // });
            // if (props.selectable && (data.reference_group_id ?? null)) {
            //   // referenceGroupInput.value.value = data.reference_group_id;
            //   referenceGroupInput.value.setValue(data.reference_group_id);
            // }
            return computeAndSetPotData(data);
        }
        async function computeAndSetPotData(data) {
            const seq = ++potDataSeq;
            try {
                const result = await computePotData(data);
                if (seq !== potDataSeq)
                    return; // superseded by a newer call — keep the newest state
                potData.value = result.retData;
                chartShowPotential.value = result.showPotential;
                error422.value = result.error422;
            }
            catch (error) {
                if (seq !== potDataSeq)
                    return; // superseded — swallow the stale rejection
                potData.value = defaultPotData;
                throw error;
            }
        }
        function potDataNoPotential(data) {
            return {
                thresholdAbs: data.threshold_abs,
                potThresholdAbs: data.threshold_abs,
                percThresholdAbs: 0,
                thresholdRel: data.threshold_rel,
                potThresholdRel: data.threshold_rel,
                percThresholdRel: 0,
                fatmaxAbs: data.fatmax_abs,
                potFatmaxAbs: data.fatmax_abs,
                percFatmaxAbs: 0,
                fatmaxRel: data.fatmax_rel,
                potFatmaxRel: data.fatmax_rel,
                percFatmaxRel: 0,
                weight: data.weight,
                potWeight: data.weight,
                percWeight: 0,
                vo2maxAbs: data.vo2max_abs,
                potVo2maxAbs: data.vo2max_abs,
                percVo2maxAbs: 0,
                vo2maxRel: data.vo2max_rel,
                potVo2maxRel: data.vo2max_rel,
                percVo2maxRel: 0,
                bmi: data.bmi,
                potBmi: data.bmi,
                percBmi: 0,
                vlamax: data.vlamax,
                potVlamax: data.vlamax,
                percVlamax: 0,
            };
        }
        // Pure with respect to reactive state: returns the data + the side-effect flags rather
        // than mutating potData/chartShowPotential/error422, so the caller can apply them
        // atomically under its generation-token guard (see computeAndSetPotData).
        async function computePotData(data) {
            // let retPotData: RetPotData = {};
            if (weightImprovement.value == 0 && vo2maxImprovement.value == 0 && vlamaxImprovement.value == 0) {
                const retPotData = potDataNoPotential(data);
                return Promise.resolve({ retData: retPotData, showPotential: false, error422: false });
            }
            else {
                const potWeight = data.weight * (1.0 - weightImprovement.value / 100);
                const potVo2maxAbs = data.vo2max_abs * (1.0 + vo2maxImprovement.value / 100);
                const potVo2maxRel = potVo2maxAbs / potWeight;
                const potBmi = potWeight / ((data.height / 100.0) * (data.height / 100.0));
                const potVlamax = data.vlamax * (1.0 - vlamaxImprovement.value / 100);
                const url = new URL('/api/v1/vo2max-and-vlamax-to-threshold-and-fatmax', window.location.origin);
                url.searchParams.append('locale', getLocale());
                url.searchParams.append('weight', data.weight.toString());
                url.searchParams.append('vo2max', potVo2maxAbs.toString());
                url.searchParams.append('vlamax', potVlamax.toString());
                url.searchParams.append('performance_computations_version', data.performance_computations_version);
                try {
                    const responseData = await fetchData(url, {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                        },
                    });
                    if (isObject(responseData) && responseData.fatmax !== undefined && responseData.threshold !== undefined) {
                        const potFatmaxAbs = Number(responseData.fatmax);
                        const percFatmaxAbs = Math.round(Number(-100.0 * (1.0 - potFatmaxAbs / data.fatmax_abs)) * 10) / 10;
                        const potFatmaxRel = Number(responseData.fatmax) / potWeight;
                        const percFatmaxRel = Math.round(Number(-100.0 * (1.0 - potFatmaxRel / data.fatmax_rel)) * 10) / 10;
                        const potThresholdAbs = Number(responseData.threshold);
                        const percThresholdAbs = Math.round(Number(-100.0 * (1.0 - potThresholdAbs / data.threshold_abs)) * 10) / 10;
                        const potThresholdRel = potThresholdAbs / potWeight;
                        const percThresholdRel = Math.round(Number(-100.0 * (1.0 - potThresholdRel / data.threshold_rel)) * 10) / 10;
                        const retPotData = {
                            thresholdAbs: data.threshold_abs,
                            potThresholdAbs: potThresholdAbs,
                            percThresholdAbs: percThresholdAbs,
                            thresholdRel: data.threshold_rel,
                            potThresholdRel: potThresholdRel,
                            percThresholdRel: percThresholdRel,
                            fatmaxAbs: data.fatmax_abs,
                            potFatmaxAbs: potFatmaxAbs,
                            percFatmaxAbs: percFatmaxAbs,
                            fatmaxRel: data.fatmax_rel,
                            potFatmaxRel: potFatmaxRel,
                            percFatmaxRel: percFatmaxRel,
                            weight: data.weight,
                            potWeight: potWeight,
                            percWeight: weightImprovement.value,
                            vo2maxAbs: data.vo2max_abs,
                            potVo2maxAbs: potVo2maxAbs,
                            percVo2maxAbs: vo2maxImprovement.value,
                            vlamax: data.vlamax,
                            potVlamax: potVlamax,
                            percVlamax: vlamaxImprovement.value,
                            vo2maxRel: data.vo2max_rel,
                            potVo2maxRel: potVo2maxRel,
                            percVo2maxRel: Math.round(Number(-100.0 * (1.0 - potVo2maxRel / data.vo2max_rel)) * 10) / 10,
                            bmi: data.bmi,
                            potBmi: potBmi,
                            percBmi: Math.round(Number(-100.0 * (1.0 - potBmi / data.bmi)) * 10) / 10,
                        };
                        return Promise.resolve({ retData: retPotData, showPotential: true, error422: false });
                    }
                    else {
                        throw new HttpError(500, 'Invalid response from server', responseData);
                    }
                }
                catch (error) {
                    if (isHttpErrorWithStatus(error, 401)) {
                        window.location.href = '/' + getLocale() + '/login';
                        console.warn('Unauthorized. Redirecting to login.', error);
                        return Promise.reject(error);
                    }
                    else if (isHttpErrorWithStatus(error, 408)) {
                        console.warn('Request timed out. Please try again.', error);
                        return Promise.reject(error);
                    }
                    else if (isHttpErrorWithStatus(error, 422)) {
                        const retPotData = potDataNoPotential(data);
                        return Promise.resolve({ retData: retPotData, showPotential: false, error422: true });
                    }
                    else {
                        console.warn('An Error occured.', error);
                        return Promise.reject(error);
                    }
                    // if (error.response && error.response.status == 401) {
                    //   // Request made and server responded
                    //   // console.log(error.response);
                    //   window.location.href = '/' + getLocale() + '/login';
                    //   return Promise.reject(error);
                    // } else if (error.response && error.response.status == 422) {
                    //   // Request made and server responded
                    //   // console.warn(error.response);
                    //   chartShowPotential.value = false;
                    //   error422.value = true;
                    //   const retPotData = potDataNoPotential(data);
                    //   return Promise.resolve(retPotData);
                    // } else {
                    //   // Request made and server responded
                    //   // console.warn(error);
                    //   return Promise.reject(error);
                    // }
                }
            }
        }
        function radarValueToText(value) {
            if (value > 80) {
                return ___({
                    en: 'very good',
                    de: 'sehr gut',
                });
            }
            else if (value > 60) {
                return ___({
                    en: 'good',
                    de: 'gut',
                });
            }
            else if (value > 35) {
                return ___({
                    en: 'to improve',
                    de: 'zu verbessern',
                });
            }
            else {
                return ___({
                    en: 'weak',
                    de: 'schwach',
                });
            }
        }
        function dataForChart(data) {
            const rG = data.reference_groups[referenceGroupId.value ?? 0];
            const vo2maxRel = inLimits(10, 95, (100 * (potData.value.vo2maxRel - rG.minVo2max)) / (rG.maxVo2max - rG.minVo2max));
            const potVo2maxRel = inLimits(10, 95, (100 * (potData.value.potVo2maxRel - rG.minVo2max)) / (rG.maxVo2max - rG.minVo2max));
            const vlamax = inLimits(10, 95, (100 * (rG.minVLamax - potData.value.vlamax)) / (rG.minVLamax - rG.maxVLamax));
            const potVlamax = inLimits(10, 95, (100 * (rG.minVLamax - potData.value.potVlamax)) / (rG.minVLamax - rG.maxVLamax));
            const thresholdAbs = inLimits(10, 95, (100 * (potData.value.thresholdAbs - rG.minThresholdabs)) / (rG.maxThresholdabs - rG.minThresholdabs));
            const potThresholdAbs = inLimits(10, 95, (100 * (potData.value.potThresholdAbs - rG.minThresholdabs)) / (rG.maxThresholdabs - rG.minThresholdabs));
            const thresholdRel = inLimits(10, 95, (100 * (potData.value.thresholdRel - rG.minThresholdrel)) / (rG.maxThresholdrel - rG.minThresholdrel));
            const potThresholdRel = inLimits(10, 95, (100 * (potData.value.potThresholdRel - rG.minThresholdrel)) / (rG.maxThresholdrel - rG.minThresholdrel));
            const fatmaxRel = inLimits(10, 95, (100 * (potData.value.fatmaxRel - rG.minFatmaxrel)) / (rG.maxFatmaxrel - rG.minFatmaxrel));
            const potFatmaxRel = inLimits(10, 95, (100 * (potData.value.potFatmaxRel - rG.minFatmaxrel)) / (rG.maxFatmaxrel - rG.minFatmaxrel));
            const bmi = inLimits(10, 95, (100 * (rG.minBmi - potData.value.bmi)) / (rG.minBmi - rG.maxBmi));
            const potBmi = inLimits(10, 95, (100 * (rG.minBmi - potData.value.potBmi)) / (rG.minBmi - rG.maxBmi));
            let returnVal = {};
            returnVal['analysis'] = [vo2maxRel, vlamax, thresholdAbs, thresholdRel, fatmaxRel, bmi];
            if (chartShowPotential.value) {
                returnVal['potential'] = [potVo2maxRel, potVlamax, potThresholdAbs, potThresholdRel, potFatmaxRel, potBmi];
            }
            return returnVal;
        }
        function rawDataForChart(data) {
            let rawData = {};
            rawData['analysis'] = [
                data.vo2max_rel,
                data.vlamax,
                data.threshold_abs,
                data.threshold_rel,
                data.fatmax_rel,
                data.bmi,
            ];
            if (chartShowPotential.value) {
                rawData['potential'] = [
                    potData.value.potVo2maxAbs / potData.value.potWeight,
                    potData.value.potVlamax,
                    potData.value.potThresholdAbs,
                    potData.value.potThresholdRel,
                    potData.value.potFatmaxRel,
                    potData.value.potBmi,
                ];
            }
            return rawData;
        }
        function getChartData(data) {
            const chartData = dataForChart(data);
            const rawData = rawDataForChart(data);
            let datasets = [];
            datasets.push({
                backgroundColor: color('#000000').alpha(0.1).rgbString(),
                borderColor: '#000000',
                pointBackgroundColor: '#000000',
                label: ___({
                    en: 'Analysis',
                    de: 'Analyse',
                }),
                data: chartData['analysis'],
                rawData: rawData['analysis'],
            });
            if (chartShowPotential.value) {
                datasets.push({
                    backgroundColor: color('#000000').alpha(0.1).rgbString(),
                    borderColor: '#000000',
                    pointBackgroundColor: '#000000',
                    borderDash: [5, 5],
                    label: ___({
                        en: 'Potential',
                        de: 'Potenzial',
                    }),
                    data: chartData['potential'],
                    rawData: rawData['potential'],
                });
            }
            datasets.push({
                backgroundColor: '#636362',
                borderColor: '#636362',
                pointBackgroundColor: '#636362',
                label: radarValueToText(24),
                pointRadius: 0,
                pointHoverRadius: 0,
                pointHitRadius: 0,
                showLine: false,
                borderWidth: 0,
                data: [35, 35, 35, 35, 35, 35],
            });
            datasets.push({
                backgroundColor: '#ffffff',
                borderColor: '#ffffff',
                pointBackgroundColor: '#ffffff',
                label: radarValueToText(49),
                pointRadius: 0,
                pointHoverRadius: 0,
                pointHitRadius: 0,
                showLine: false,
                borderWidth: 0,
                data: [60, 60, 60, 60, 60, 60],
            });
            datasets.push({
                backgroundColor: '#2CB7C1',
                borderColor: '#2CB7C1',
                pointBackgroundColor: '#2CB7C1',
                label: radarValueToText(74),
                pointRadius: 0,
                pointHoverRadius: 0,
                pointHitRadius: 0,
                showLine: false,
                borderWidth: 0,
                data: [80, 80, 80, 80, 80, 80],
            });
            datasets.push({
                backgroundColor: '#CDB663',
                borderColor: '#CDB663',
                pointBackgroundColor: '#CDB663',
                label: radarValueToText(99),
                pointRadius: 0,
                pointHoverRadius: 0,
                pointHitRadius: 0,
                showLine: false,
                borderWidth: 0,
                data: [100, 100, 100, 100, 100, 100],
            });
            return {
                labels: [
                    ___({ en: 'VO2max', de: 'VO2max' }),
                    ___({ en: 'VLamax', de: 'VLamax' }),
                    ___({ en: 'abs. Threshold', de: 'abs. ANS' }),
                    ___({ en: 'rel. Threshold', de: 'rel. ANS' }),
                    ___({ en: 'Fatmax', de: 'Fatmax' }),
                    ___({ en: 'BMI', de: 'BMI' }),
                ],
                datasets: datasets,
            };
        }
        function drawChart(data) {
            if (chart.value === null)
                return;
            const chartData = getChartData(data);
            const chartOptions = {
                maintainAspectRatio: false,
                responsive: true,
                animation: false,
                scales: {
                    r: {
                        max: 100,
                        min: 0,
                        ticks: {
                            display: false,
                        },
                    },
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'right',
                        onClick: () => {
                            return;
                        },
                    },
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: (context) => {
                                return context[0].label;
                            },
                            label: (context) => {
                                let decNum = 1;
                                let unitStr = '';
                                switch (context.label) {
                                    case 'VO2max':
                                        decNum = 1;
                                        unitStr = 'ml/min/kg';
                                        break;
                                    case 'VLamax':
                                        decNum = 3;
                                        unitStr = 'mmol/l/s';
                                        break;
                                    case 'abs. Threshold':
                                    case 'abs. ANS':
                                        decNum = 1;
                                        unitStr = 'W';
                                        break;
                                    case 'rel. Threshold':
                                    case 'rel. ANS':
                                        decNum = 2;
                                        unitStr = 'W/kg';
                                        break;
                                    case 'Fatmax':
                                        decNum = 2;
                                        unitStr = 'W/kg';
                                        break;
                                    case 'BMI':
                                    case 'BMI':
                                        decNum = 1;
                                        unitStr = '';
                                        break;
                                    default:
                                        decNum = 1;
                                        unitStr = '';
                                }
                                return toFixedNumberStr(context.dataset.rawData[context.dataIndex] ?? undefined, decNum) + ' ' + unitStr;
                            },
                        },
                    },
                },
            };
            if (chartObj === undefined) {
                chartObj = new Chart(chart.value, {
                    type: 'radar',
                    data: chartData,
                    options: chartOptions,
                });
                showPlaceholder.value = false;
            }
            else {
                chartObj.data = chartData;
                chartObj.options = chartOptions;
                chartObj.update();
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(___)({
                                    en: 'Unlock Your Potential',
                                    de: 'Erkenne dein Potenzial',
                                })), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(LabeledSlider, {
                                    class: "mb-3",
                                    value: weightImprovement.value,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((weightImprovement).value = $event)),
                                    title: _unref(___)({
                                        en: 'Weight loss',
                                        de: 'Gewichtsverlust',
                                    }),
                                    "help-text": _unref(___)({
                                        en: 'Weight loss compared to the original analysis',
                                        de: 'Gewichtsverlust im Vergleich zur ursprünglichen Analyse',
                                    }),
                                    unit: "%",
                                    min: 0,
                                    max: 15,
                                    step: 1
                                }, null, 8 /* PROPS */, ["value", "title", "help-text"]),
                                _createVNode(LabeledSlider, {
                                    class: "mb-3",
                                    value: vlamaxImprovement.value,
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((vlamaxImprovement).value = $event)),
                                    title: _unref(___)({ en: 'Improvement VLamax ', de: 'Verbesserung VLamax' }),
                                    "help-text": _unref(___)({ en: 'Improvement (reduction) of the VLamax in relation to the original analysis', de: 'Verbesserung (Verringerung) der VLamax im Verhältnis zur ursprünglichen Analyse' }),
                                    unit: "%",
                                    min: 0,
                                    max: 15,
                                    step: 1
                                }, null, 8 /* PROPS */, ["value", "title", "help-text"]),
                                _createVNode(LabeledSlider, {
                                    class: "mb-3",
                                    value: vo2maxImprovement.value,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event) => ((vo2maxImprovement).value = $event)),
                                    title: _unref(___)({ en: 'Improvement absolute VO2max ', de: 'Verbesserung absolute VO2max' }),
                                    "help-text": _unref(___)({ en: 'Improvement of the VO2max in relation to the original analysis', de: 'Verbesserung der VO2max im Verhältnis zur ursprünglichen Analyse' }),
                                    unit: "%",
                                    min: 0,
                                    max: 15,
                                    step: 1
                                }, null, 8 /* PROPS */, ["value", "title", "help-text"]),
                                (__props.selectable)
                                    ? (_openBlock(), _createBlock(LabeledSelect, {
                                        key: 0,
                                        class: "",
                                        title: _unref(___)({ en: 'Reference group', de: 'Referenzgruppe' }),
                                        help: _unref(___)({ en: 'Reference group', de: 'Referenzgruppe' }),
                                        value: referenceGroupIdStr.value,
                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event) => ((referenceGroupIdStr).value = $event)),
                                        "empty-option": emptyReferenceOption,
                                        options: referenceOptions.value,
                                        required: false,
                                        disabled: false
                                    }, null, 8 /* PROPS */, ["title", "help", "value", "options"]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(___)({
                                    en: 'Your Potential',
                                    de: 'Dein Potenzial',
                                })), 1 /* TEXT */)
                            ]),
                            _createElementVNode("ul", _hoisted_11, [
                                _createElementVNode("li", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(___)({ en: 'Weight', de: 'Gewicht' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percWeight > 0.0, 'text-red-500': potData.value.percWeight < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percWeight, 1))
                                                }, null, 8 /* PROPS */, _hoisted_15),
                                                _cache[5] || (_cache[5] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potWeight, 1))
                                                }, null, 8 /* PROPS */, _hoisted_17),
                                                _cache[6] || (_cache[6] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.weight, 1))
                                                }, null, 8 /* PROPS */, _hoisted_18),
                                                _cache[7] || (_cache[7] = _createTextVNode(" kg", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(___)({ en: 'Body-Mass-Index', de: 'Body-Mass-Index' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percBmi < 0.0, 'text-red-500': potData.value.percBmi > 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percBmi, 1))
                                                }, null, 8 /* PROPS */, _hoisted_22),
                                                _cache[8] || (_cache[8] = _createTextVNode(" %", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potBmi, 1))
                                                }, null, 8 /* PROPS */, _hoisted_24),
                                                _cache[9] || (_cache[9] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.bmi, 1))
                                                }, null, 8 /* PROPS */, _hoisted_25)
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(___)({ en: 'VLamax', de: 'VLamax' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percVlamax > 0.0, 'text-red-500': potData.value.percVlamax < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percVlamax, 1))
                                                }, null, 8 /* PROPS */, _hoisted_29),
                                                _cache[10] || (_cache[10] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potVlamax, 2))
                                                }, null, 8 /* PROPS */, _hoisted_31),
                                                _cache[11] || (_cache[11] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.vlamax, 2))
                                                }, null, 8 /* PROPS */, _hoisted_32),
                                                _cache[12] || (_cache[12] = _createTextVNode(" mmol/l/s", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(___)({ en: 'Absolute VO2max', de: 'Absolute VO2max' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percVo2maxAbs > 0.0, 'text-red-500': potData.value.percVo2maxAbs < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percVo2maxAbs, 1))
                                                }, null, 8 /* PROPS */, _hoisted_36),
                                                _cache[13] || (_cache[13] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_37, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potVo2maxAbs, 0))
                                                }, null, 8 /* PROPS */, _hoisted_38),
                                                _cache[14] || (_cache[14] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.vo2maxAbs, 0))
                                                }, null, 8 /* PROPS */, _hoisted_39),
                                                _cache[15] || (_cache[15] = _createTextVNode(" ml/min", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(___)({ en: 'Relative VO2max', de: 'Relative VO2max' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percVo2maxRel > 0.0, 'text-red-500': potData.value.percVo2maxRel < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percVo2maxRel, 1))
                                                }, null, 8 /* PROPS */, _hoisted_43),
                                                _cache[16] || (_cache[16] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potVo2maxRel, 1))
                                                }, null, 8 /* PROPS */, _hoisted_45),
                                                _cache[17] || (_cache[17] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.vo2maxRel, 1))
                                                }, null, 8 /* PROPS */, _hoisted_46),
                                                _cache[18] || (_cache[18] = _createTextVNode(" ml/min/kg ", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(___)({ en: 'Absolute threshold power', de: 'Absolute Schwellenleistung' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percThresholdAbs > 0.0, 'text-red-500': potData.value.percThresholdAbs < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percThresholdAbs, 1))
                                                }, null, 8 /* PROPS */, _hoisted_50),
                                                _cache[19] || (_cache[19] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potThresholdAbs, 1))
                                                }, null, 8 /* PROPS */, _hoisted_52),
                                                _cache[20] || (_cache[20] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.thresholdAbs, 1))
                                                }, null, 8 /* PROPS */, _hoisted_53),
                                                _cache[21] || (_cache[21] = _createTextVNode(" W ", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(___)({ en: 'Relative threshold power', de: 'Relative Schwellenleistung' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percThresholdRel > 0.0, 'text-red-500': potData.value.percThresholdRel < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percThresholdRel, 1))
                                                }, null, 8 /* PROPS */, _hoisted_57),
                                                _cache[22] || (_cache[22] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_58, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potThresholdRel, 2))
                                                }, null, 8 /* PROPS */, _hoisted_59),
                                                _cache[23] || (_cache[23] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.thresholdRel, 2))
                                                }, null, 8 /* PROPS */, _hoisted_60),
                                                _cache[24] || (_cache[24] = _createTextVNode(" W/kg ", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_61, [
                                    _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(___)({ en: 'Absolute Fatmax', de: 'Absolute Fatmax' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_63, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percFatmaxAbs > 0.0, 'text-red-500': potData.value.percFatmaxAbs < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percFatmaxAbs, 1))
                                                }, null, 8 /* PROPS */, _hoisted_64),
                                                _cache[25] || (_cache[25] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_65, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potFatmaxAbs, 2))
                                                }, null, 8 /* PROPS */, _hoisted_66),
                                                _cache[26] || (_cache[26] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.fatmaxAbs, 2))
                                                }, null, 8 /* PROPS */, _hoisted_67),
                                                _cache[27] || (_cache[27] = _createTextVNode(" W", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("li", _hoisted_68, [
                                    _createElementVNode("div", _hoisted_69, _toDisplayString(_unref(___)({ en: 'Relative Fatmax', de: 'Relative Fatmax' })), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["", { 'text-emerald-500': potData.value.percFatmaxRel > 0.0, 'text-red-500': potData.value.percFatmaxRel < 0.0 }])
                                            }, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.percFatmaxRel, 1))
                                                }, null, 8 /* PROPS */, _hoisted_71),
                                                _cache[28] || (_cache[28] = _createTextVNode(" % ", -1 /* CACHED */))
                                            ], 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_72, [
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.potFatmaxRel, 2))
                                                }, null, 8 /* PROPS */, _hoisted_73),
                                                _cache[29] || (_cache[29] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                                _createElementVNode("span", {
                                                    textContent: _toDisplayString(_unref(toFixedNumberStr)(potData.value.fatmaxRel, 2))
                                                }, null, 8 /* PROPS */, _hoisted_74),
                                                _cache[30] || (_cache[30] = _createTextVNode(" W/kg", -1 /* CACHED */))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    (potData.value.potVlamax < 0.15)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(___)({
                                en: 'Attention: The potential VLamax is outside a physiologically reasonable range of values.',
                                de: 'Achtung: Die potenzielle VLamax befindet sich außerhalb eines physiologisch sinnvollen Wertebereichs.',
                            })), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true),
                    (potData.value.potVo2maxRel > 95.0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, _toDisplayString(_unref(___)({
                                en: 'Attention: The potential relative VO2max is outside a physiologically reasonable range of values.',
                                de: 'Achtung: Die potenzielle relative VO2max befindet sich außerhalb eines physiologisch sinnvollen Wertebereichs.',
                            })), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true),
                    (error422.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, _toDisplayString(_unref(___)({
                                en: 'Attention: For the given improvements the potential performance metrics are outside of the physiologically reasonable range of values.',
                                de: 'Achtung: Für die angegebenen Verbesserungen liegen die Leistungskennzahlen außerhalb des physiologisch sinnvollen Wertebereichs.',
                            })), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, _toDisplayString(_unref(___)({
                            en: 'Performance Profile',
                            de: 'Leistungsprofil',
                        })), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", {
                            class: "absolute inset-0",
                            ref_key: "containerRef",
                            ref: containerRef
                        }, [
                            _createElementVNode("canvas", {
                                class: "w-full h-full",
                                ref_key: "chart",
                                ref: chart
                            }, null, 512 /* NEED_PATCH */)
                        ], 512 /* NEED_PATCH */),
                        (showPlaceholder.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                _createElementVNode("div", null, [
                                    _cache[4] || (_setBlockTracking(-1, true),
                                        (_cache[4] = _createVNode(SvgVue, {
                                            class: "w-4 h-4",
                                            icon: "lucide/chart-line"
                                        })).cacheIndex = 4,
                                        _setBlockTracking(1),
                                        _cache[4]),
                                    _createTextVNode(" " + _toDisplayString(_unref(___)({ en: 'loading...', de: 'lädt...' })), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
